// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptCollectionInvitationData, AcceptCollectionInvitationErrors, AcceptCollectionInvitationResponses, AcceptInvitationData, AcceptInvitationErrors, AcceptInvitationResponses, AcceptOrganizationInvitationData, AcceptOrganizationInvitationErrors, AcceptOrganizationInvitationResponses, AgentProxyCommandData, AgentProxyCommandErrors, AgentProxyCommandResponses, AgentProxyStreamCommandData, AgentProxyStreamCommandErrors, AgentProxyStreamCommandResponses, AnalyzeAidatabaseData, AnalyzeAidatabaseResponses, BlockUserData, BlockUserErrors, BlockUserResponses, BulkReorderDatasourcesData, BulkReorderDatasourcesErrors, BulkReorderDatasourcesResponses, ChatAiData, ChatAiResponses, CreateAgentsData, CreateAgentsErrors, CreateAgentsResponses, CreateCollectionData, CreateCollectionErrors, CreateCollectionQueryData, CreateCollectionQueryErrors, CreateCollectionQueryResponses, CreateCollectionResponses, CreateDatasourceFolderData, CreateDatasourceFolderErrors, CreateDatasourceFolderResponses, CreateDatasourcesData, CreateDatasourcesErrors, CreateDatasourcesResponses, CreateFolderData, CreateFolderErrors, CreateFolderResponses, CreateLoginData, CreateLoginErrors, CreateLoginResponses, CreateLogoutData, CreateLogoutErrors, CreateLogoutResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationResponses, CreateOrUpdateUserEmailPolicyData, CreateOrUpdateUserEmailPolicyErrors, CreateOrUpdateUserEmailPolicyResponses, DeleteAgentsData, DeleteAgentsErrors, DeleteAgentsResponses, DeleteAihistoryData, DeleteAihistoryErrors, DeleteAihistoryResponses, DeleteCollectionData, DeleteCollectionErrors, DeleteCollectionQueryData, DeleteCollectionQueryErrors, DeleteCollectionQueryResponses, DeleteCollectionResponses, DeleteDatasourceFolderData, DeleteDatasourceFolderErrors, DeleteDatasourceFolderResponses, DeleteDatasourcesData, DeleteDatasourcesErrors, DeleteDatasourcesResponses, DeleteFolderData, DeleteFolderErrors, DeleteFolderResponses, DeleteOrganizationData, DeleteOrganizationErrors, DeleteOrganizationResponses, DeleteSessionsData, DeleteSessionsErrors, DeleteSessionsResponses, DeleteUserData, DeleteUserEmailPolicyData, DeleteUserEmailPolicyErrors, DeleteUserEmailPolicyResponses, DeleteUserErrors, DeleteUserResponses, ExecuteQueryAiData, ExecuteQueryAiexplainData, ExecuteQueryAiexplainResponses, ExecuteQueryAiResponses, GetAgentByIdData, GetAgentByIdErrors, GetAgentByIdResponses, GetAgentDatasourcesData, GetAgentDatasourcesErrors, GetAgentDatasourcesResponses, GetAgentsData, GetAgentsErrors, GetAgentsResponses, GetAgentStatusData, GetAgentStatusErrors, GetAgentStatusResponses, GetAihistoryData, GetAihistoryResponses, GetCollectionData, GetCollectionErrors, GetCollectionPermissionsData, GetCollectionPermissionsErrors, GetCollectionPermissionsResponses, GetCollectionQueryData, GetCollectionQueryErrors, GetCollectionQueryResponses, GetCollectionResponses, GetCurrentUserData, GetCurrentUserErrors, GetCurrentUserResponses, GetDatasourceByIdData, GetDatasourceByIdErrors, GetDatasourceByIdResponses, GetDatasourceFolderData, GetDatasourceFolderErrors, GetDatasourceFolderResponses, GetDatasourceFoldersData, GetDatasourceFoldersErrors, GetDatasourceFoldersResponses, GetDatasourcesData, GetDatasourcesErrors, GetDatasourcesResponses, GetFolderData, GetFolderErrors, GetFolderResponses, GetHistoryData, GetHistoryErrors, GetHistoryResponses, GetOrganizationData, GetOrganizationErrors, GetOrganizationInvitationsData, GetOrganizationInvitationsErrors, GetOrganizationInvitationsResponses, GetOrganizationMembersData, GetOrganizationMembersErrors, GetOrganizationMembersResponses, GetOrganizationResponses, GetOrganizationsData, GetOrganizationsErrors, GetOrganizationSharedAgentsData, GetOrganizationSharedAgentsErrors, GetOrganizationSharedAgentsResponses, GetOrganizationSharedCollectionsData, GetOrganizationSharedCollectionsErrors, GetOrganizationSharedCollectionsResponses, GetOrganizationSharedDatasourcesData, GetOrganizationSharedDatasourcesErrors, GetOrganizationSharedDatasourcesResponses, GetOrganizationsResponses, GetSessionData, GetSessionErrors, GetSessionResponses, GetSessionsData, GetSessionsResponses, GetSettingsData, GetSettingsResponses, GetSitemapData, GetSitemapResponses, GetUserByIdData, GetUserByIdErrors, GetUserByIdResponses, GetUserEmailPolicyData, GetUserEmailPolicyErrors, GetUserEmailPolicyResponses, GetUserFeatureFlagsData, GetUserFeatureFlagsErrors, GetUserFeatureFlagsResponses, GetUsersData, GetUsersErrors, GetUsersResponses, GrantCollectionPermissionData, GrantCollectionPermissionErrors, GrantCollectionPermissionResponses, HealthCheckData, HealthCheckErrors, HealthCheckResponses, InviteToOrganizationData, InviteToOrganizationErrors, InviteToOrganizationResponses, InviteUserToAgentData, InviteUserToAgentErrors, InviteUserToAgentResponses, InviteUserToCollectionData, InviteUserToCollectionErrors, InviteUserToCollectionResponses, LeaveSharedAgentData, LeaveSharedAgentErrors, LeaveSharedAgentResponses, LeaveSharedCollectionData, LeaveSharedCollectionErrors, LeaveSharedCollectionResponses, ListAgentInvitationsData, ListAgentInvitationsErrors, ListAgentInvitationsResponses, ListAgentPermissionsData, ListAgentPermissionsErrors, ListAgentPermissionsResponses, ListBlockedUsersData, ListBlockedUsersErrors, ListBlockedUsersResponses, ListCollectionFoldersData, ListCollectionFoldersErrors, ListCollectionFoldersResponses, ListCollectionInvitationsData, ListCollectionInvitationsErrors, ListCollectionInvitationsResponses, ListCollectionQueriesData, ListCollectionQueriesErrors, ListCollectionQueriesResponses, ListCollectionsData, ListCollectionsErrors, ListCollectionsResponses, ListMyInvitationsData, ListMyInvitationsErrors, ListMyInvitationsResponses, ListSharedAgentsData, ListSharedAgentsErrors, ListSharedAgentsResponses, ListSharedCollectionsData, ListSharedCollectionsErrors, ListSharedCollectionsResponses, ListUserInvitationsData, ListUserInvitationsErrors, ListUserInvitationsResponses, MoveCollectionQueryData, MoveCollectionQueryErrors, MoveCollectionQueryResponses, MoveDatasourceToFolderData, MoveDatasourceToFolderErrors, MoveDatasourceToFolderResponses, RefreshData, RefreshErrors, RefreshResponses, RegenerateAgentApiKeyData, RegenerateAgentApiKeyErrors, RegenerateAgentApiKeyResponses, RegisterUserData, RegisterUserErrors, RegisterUserResponses, RejectCollectionInvitationData, RejectCollectionInvitationErrors, RejectCollectionInvitationResponses, RejectInvitationData, RejectInvitationErrors, RejectInvitationResponses, RemoveAgentPermissionData, RemoveAgentPermissionErrors, RemoveAgentPermissionResponses, RemoveOrganizationMemberData, RemoveOrganizationMemberErrors, RemoveOrganizationMemberResponses, ReorderCollectionFoldersData, ReorderCollectionFoldersErrors, ReorderCollectionFoldersResponses, ReorderCollectionQueriesData, ReorderCollectionQueriesErrors, ReorderCollectionQueriesResponses, ReorderCollectionsData, ReorderCollectionsErrors, ReorderCollectionsResponses, ReorderDatasourceFoldersData, ReorderDatasourceFoldersErrors, ReorderDatasourceFoldersResponses, ResetAgentApiKeyData, ResetAgentApiKeyErrors, ResetAgentApiKeyResponses, RevokeCollectionInvitationData, RevokeCollectionInvitationErrors, RevokeCollectionInvitationResponses, RevokeCollectionPermissionData, RevokeCollectionPermissionErrors, RevokeCollectionPermissionResponses, RevokeInvitationData, RevokeInvitationErrors, RevokeInvitationResponses, ShareAgentWithOrganizationData, ShareAgentWithOrganizationErrors, ShareAgentWithOrganizationResponses, ShareCollectionWithOrganizationData, ShareCollectionWithOrganizationErrors, ShareCollectionWithOrganizationResponses, UnblockUserData, UnblockUserErrors, UnblockUserResponses, UpdateAgentPermissionData, UpdateAgentPermissionErrors, UpdateAgentPermissionResponses, UpdateAgentsData, UpdateAgentsErrors, UpdateAgentsResponses, UpdateCollectionData, UpdateCollectionErrors, UpdateCollectionQueryData, UpdateCollectionQueryErrors, UpdateCollectionQueryResponses, UpdateCollectionResponses, UpdateCurrentUserData, UpdateCurrentUserErrors, UpdateCurrentUserResponses, UpdateDatasourceFolderData, UpdateDatasourceFolderErrors, UpdateDatasourceFolderResponses, UpdateDatasourceOrderData, UpdateDatasourceOrderErrors, UpdateDatasourceOrderResponses, UpdateDatasourcesData, UpdateDatasourcesErrors, UpdateDatasourcesResponses, UpdateFolderData, UpdateFolderErrors, UpdateFolderResponses, UpdateMemberPermissionData, UpdateMemberPermissionErrors, UpdateMemberPermissionResponses, UpdateOrganizationData, UpdateOrganizationErrors, UpdateOrganizationResponses, UpdateSettingsData, UpdateSettingsResponses, UpdateUserByIdData, UpdateUserByIdErrors, UpdateUserByIdResponses, UpdateUserFeatureFlagsData, UpdateUserFeatureFlagsErrors, UpdateUserFeatureFlagsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Health check endpoint
 *
 * Check API and database connectivity status
 */
export const healthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError>({ url: '/health', ...options });

/**
 * User registration
 *
 * Register a new user account
 */
export const registerUser = <ThrowOnError extends boolean = false>(options: Options<RegisterUserData, ThrowOnError>) => (options.client ?? client).post<RegisterUserResponses, RegisterUserErrors, ThrowOnError>({
    url: '/api/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * User login
 *
 * Authenticate user and return JWT token
 */
export const createLogin = <ThrowOnError extends boolean = false>(options: Options<CreateLoginData, ThrowOnError>) => (options.client ?? client).post<CreateLoginResponses, CreateLoginErrors, ThrowOnError>({
    url: '/api/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * User logout
 *
 * Revoke current JWT token
 */
export const createLogout = <ThrowOnError extends boolean = false>(options?: Options<CreateLogoutData, ThrowOnError>) => (options?.client ?? client).post<CreateLogoutResponses, CreateLogoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/logout',
    ...options
});

/**
 * Refresh JWT token
 *
 * Get new JWT token using refresh token
 */
export const refresh = <ThrowOnError extends boolean = false>(options: Options<RefreshData, ThrowOnError>) => (options.client ?? client).post<RefreshResponses, RefreshErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List users
 *
 * Get paginated list of all users. Only admin users can access this endpoint.
 */
export const getUsers = <ThrowOnError extends boolean = false>(options?: Options<GetUsersData, ThrowOnError>) => (options?.client ?? client).get<GetUsersResponses, GetUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users',
    ...options
});

/**
 * Get current user profile
 *
 * Get the profile information of the currently authenticated user
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserData, ThrowOnError>) => (options?.client ?? client).get<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user',
    ...options
});

/**
 * Update current user profile
 *
 * Update the profile information of the currently authenticated user
 */
export const updateCurrentUser = <ThrowOnError extends boolean = false>(options: Options<UpdateCurrentUserData, ThrowOnError>) => (options.client ?? client).put<UpdateCurrentUserResponses, UpdateCurrentUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete user's email domain policy
 *
 * Delete the current user's email domain filtering policy, allowing invitations from all domains
 */
export const deleteUserEmailPolicy = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserEmailPolicyData, ThrowOnError>) => (options?.client ?? client).delete<DeleteUserEmailPolicyResponses, DeleteUserEmailPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/email-policy',
    ...options
});

/**
 * Get user's email domain policy
 *
 * Get the current user's email domain filtering policy for agent invitations
 */
export const getUserEmailPolicy = <ThrowOnError extends boolean = false>(options?: Options<GetUserEmailPolicyData, ThrowOnError>) => (options?.client ?? client).get<GetUserEmailPolicyResponses, GetUserEmailPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/email-policy',
    ...options
});

/**
 * Create or update user's email domain policy
 *
 * Create or update the current user's email domain filtering policy for agent invitations
 */
export const createOrUpdateUserEmailPolicy = <ThrowOnError extends boolean = false>(options: Options<CreateOrUpdateUserEmailPolicyData, ThrowOnError>) => (options.client ?? client).post<CreateOrUpdateUserEmailPolicyResponses, CreateOrUpdateUserEmailPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/email-policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete user account
 *
 * Delete a user account and all associated data. Only admin users can perform this action.
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}',
    ...options
});

/**
 * Get specific user details
 *
 * Get detailed information about a specific user. Only admin users can access this endpoint.
 */
export const getUserById = <ThrowOnError extends boolean = false>(options: Options<GetUserByIdData, ThrowOnError>) => (options.client ?? client).get<GetUserByIdResponses, GetUserByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}',
    ...options
});

/**
 * Update user by admin
 *
 * Update a specific user's information. Only admin users can perform this action.
 */
export const updateUserById = <ThrowOnError extends boolean = false>(options: Options<UpdateUserByIdData, ThrowOnError>) => (options.client ?? client).put<UpdateUserByIdResponses, UpdateUserByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user feature flags
 *
 * Get feature flags for a specific user. Only admin users can access this endpoint.
 */
export const getUserFeatureFlags = <ThrowOnError extends boolean = false>(options: Options<GetUserFeatureFlagsData, ThrowOnError>) => (options.client ?? client).get<GetUserFeatureFlagsResponses, GetUserFeatureFlagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}/feature-flags',
    ...options
});

/**
 * Update user feature flags
 *
 * Update feature flags for a specific user. Only admin users can perform this action.
 */
export const updateUserFeatureFlags = <ThrowOnError extends boolean = false>(options: Options<UpdateUserFeatureFlagsData, ThrowOnError>) => (options.client ?? client).put<UpdateUserFeatureFlagsResponses, UpdateUserFeatureFlagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}/feature-flags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List data sources
 *
 * Get paginated list of user's data sources
 */
export const getDatasources = <ThrowOnError extends boolean = false>(options?: Options<GetDatasourcesData, ThrowOnError>) => (options?.client ?? client).get<GetDatasourcesResponses, GetDatasourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasources',
    ...options
});

/**
 * Create data source
 *
 * Create a new database connection
 */
export const createDatasources = <ThrowOnError extends boolean = false>(options: Options<CreateDatasourcesData, ThrowOnError>) => (options.client ?? client).post<CreateDatasourcesResponses, CreateDatasourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete data source
 *
 * Remove a data source connection
 */
export const deleteDatasources = <ThrowOnError extends boolean = false>(options: Options<DeleteDatasourcesData, ThrowOnError>) => (options.client ?? client).delete<DeleteDatasourcesResponses, DeleteDatasourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasources/{datasource_id}',
    ...options
});

/**
 * Get data source details
 *
 * Retrieve detailed information about a specific data source
 */
export const getDatasourceById = <ThrowOnError extends boolean = false>(options: Options<GetDatasourceByIdData, ThrowOnError>) => (options.client ?? client).get<GetDatasourceByIdResponses, GetDatasourceByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasources/{datasource_id}',
    ...options
});

/**
 * Update data source
 *
 * Update data source configuration
 */
export const updateDatasources = <ThrowOnError extends boolean = false>(options: Options<UpdateDatasourcesData, ThrowOnError>) => (options.client ?? client).put<UpdateDatasourcesResponses, UpdateDatasourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasources/{datasource_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update datasource order
 *
 * Update the display order of a specific datasource. This will adjust the order of other datasources to maintain contiguous ordering.
 */
export const updateDatasourceOrder = <ThrowOnError extends boolean = false>(options: Options<UpdateDatasourceOrderData, ThrowOnError>) => (options.client ?? client).put<UpdateDatasourceOrderResponses, UpdateDatasourceOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasources/{datasource_id}/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk reorder datasources
 *
 * Reorder multiple datasources at once by providing an ordered list of datasource IDs. The datasources will be assigned order values starting from 0.
 */
export const bulkReorderDatasources = <ThrowOnError extends boolean = false>(options: Options<BulkReorderDatasourcesData, ThrowOnError>) => (options.client ?? client).post<BulkReorderDatasourcesResponses, BulkReorderDatasourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasources/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List datasource folders
 *
 * Get paginated list of user's datasource folders
 */
export const getDatasourceFolders = <ThrowOnError extends boolean = false>(options?: Options<GetDatasourceFoldersData, ThrowOnError>) => (options?.client ?? client).get<GetDatasourceFoldersResponses, GetDatasourceFoldersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasource-folders',
    ...options
});

/**
 * Create datasource folder
 *
 * Create a new folder for organizing datasources
 */
export const createDatasourceFolder = <ThrowOnError extends boolean = false>(options: Options<CreateDatasourceFolderData, ThrowOnError>) => (options.client ?? client).post<CreateDatasourceFolderResponses, CreateDatasourceFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasource-folders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete datasource folder
 *
 * Delete a folder. Subfolders are moved to parent, datasources become uncategorized
 */
export const deleteDatasourceFolder = <ThrowOnError extends boolean = false>(options: Options<DeleteDatasourceFolderData, ThrowOnError>) => (options.client ?? client).delete<DeleteDatasourceFolderResponses, DeleteDatasourceFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasource-folders/{folder_id}',
    ...options
});

/**
 * Get datasource folder
 *
 * Get details of a specific folder
 */
export const getDatasourceFolder = <ThrowOnError extends boolean = false>(options: Options<GetDatasourceFolderData, ThrowOnError>) => (options.client ?? client).get<GetDatasourceFolderResponses, GetDatasourceFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasource-folders/{folder_id}',
    ...options
});

/**
 * Update datasource folder
 *
 * Update folder name, description, or parent
 */
export const updateDatasourceFolder = <ThrowOnError extends boolean = false>(options: Options<UpdateDatasourceFolderData, ThrowOnError>) => (options.client ?? client).put<UpdateDatasourceFolderResponses, UpdateDatasourceFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasource-folders/{folder_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk reorder folders
 *
 * Reorder multiple folders at once
 */
export const reorderDatasourceFolders = <ThrowOnError extends boolean = false>(options: Options<ReorderDatasourceFoldersData, ThrowOnError>) => (options.client ?? client).post<ReorderDatasourceFoldersResponses, ReorderDatasourceFoldersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasource-folders/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move datasource to folder
 *
 * Move a datasource to a folder or to root (uncategorized)
 */
export const moveDatasourceToFolder = <ThrowOnError extends boolean = false>(options: Options<MoveDatasourceToFolderData, ThrowOnError>) => (options.client ?? client).put<MoveDatasourceToFolderResponses, MoveDatasourceToFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/datasources/{datasource_id}/folder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get query history
 *
 * Retrieve user's query execution history with pagination support
 */
export const getHistory = <ThrowOnError extends boolean = false>(options?: Options<GetHistoryData, ThrowOnError>) => (options?.client ?? client).get<GetHistoryResponses, GetHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/queries/history',
    ...options
});

/**
 * List agents
 *
 * Get paginated list of database agents
 */
export const getAgents = <ThrowOnError extends boolean = false>(options?: Options<GetAgentsData, ThrowOnError>) => (options?.client ?? client).get<GetAgentsResponses, GetAgentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents',
    ...options
});

/**
 * Create agent
 *
 * Create a new database agent
 */
export const createAgents = <ThrowOnError extends boolean = false>(options: Options<CreateAgentsData, ThrowOnError>) => (options.client ?? client).post<CreateAgentsResponses, CreateAgentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete agent
 *
 * Remove an agent (requires owner or write permission)
 */
export const deleteAgents = <ThrowOnError extends boolean = false>(options: Options<DeleteAgentsData, ThrowOnError>) => (options.client ?? client).delete<DeleteAgentsResponses, DeleteAgentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}',
    ...options
});

/**
 * Get agent details
 *
 * Retrieve detailed information about an agent
 */
export const getAgentById = <ThrowOnError extends boolean = false>(options: Options<GetAgentByIdData, ThrowOnError>) => (options.client ?? client).get<GetAgentByIdResponses, GetAgentByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}',
    ...options
});

/**
 * Update agent
 *
 * Update agent configuration
 */
export const updateAgents = <ThrowOnError extends boolean = false>(options: Options<UpdateAgentsData, ThrowOnError>) => (options.client ?? client).put<UpdateAgentsResponses, UpdateAgentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Regenerate agent API key
 *
 * Generate a new API key for an existing agent (requires owner or write permission)
 */
export const regenerateAgentApiKey = <ThrowOnError extends boolean = false>(options: Options<RegenerateAgentApiKeyData, ThrowOnError>) => (options.client ?? client).post<RegenerateAgentApiKeyResponses, RegenerateAgentApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}/regenerate-api-key',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get agent status
 *
 * Retrieve current status and connection information for an agent
 */
export const getAgentStatus = <ThrowOnError extends boolean = false>(options: Options<GetAgentStatusData, ThrowOnError>) => (options.client ?? client).get<GetAgentStatusResponses, GetAgentStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}/status',
    ...options
});

/**
 * Get agent datasources
 *
 * Retrieve all datasources associated with a specific agent
 */
export const getAgentDatasources = <ThrowOnError extends boolean = false>(options: Options<GetAgentDatasourcesData, ThrowOnError>) => (options.client ?? client).get<GetAgentDatasourcesResponses, GetAgentDatasourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}/datasources',
    ...options
});

/**
 * Reset agent API key
 *
 * Reset the API key for an agent with a new provided key (requires owner or write permission)
 */
export const resetAgentApiKey = <ThrowOnError extends boolean = false>(options: Options<ResetAgentApiKeyData, ThrowOnError>) => (options.client ?? client).post<ResetAgentApiKeyResponses, ResetAgentApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}/reset-api-key',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invite user to share agent
 *
 * Send an invitation to share an agent with another user via email or username.
 *
 * **User Validation:** The system validates that the specified user exists before sending the invitation.
 * If no user is found with the provided email or username, a 404 USER_NOT_FOUND error is returned.
 *
 */
export const inviteUserToAgent = <ThrowOnError extends boolean = false>(options: Options<InviteUserToAgentData, ThrowOnError>) => (options.client ?? client).post<InviteUserToAgentResponses, InviteUserToAgentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept agent invitation
 *
 * Accept an invitation to share an agent
 */
export const acceptInvitation = <ThrowOnError extends boolean = false>(options: Options<AcceptInvitationData, ThrowOnError>) => (options.client ?? client).post<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/invitations/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject agent invitation
 *
 * Reject an invitation to share an agent
 */
export const rejectInvitation = <ThrowOnError extends boolean = false>(options: Options<RejectInvitationData, ThrowOnError>) => (options.client ?? client).post<RejectInvitationResponses, RejectInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/invitations/{invitation_token}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List agent invitations
 *
 * List all invitations for a specific agent. Only the agent owner can view this list. Returns invitations in all states (pending, accepted, rejected, expired).
 */
export const listAgentInvitations = <ThrowOnError extends boolean = false>(options: Options<ListAgentInvitationsData, ThrowOnError>) => (options.client ?? client).get<ListAgentInvitationsResponses, ListAgentInvitationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}/invitations',
    ...options
});

/**
 * Revoke agent invitation
 *
 * Revoke a pending invitation to share an agent. Only the inviter or agent owner can revoke invitations.
 */
export const revokeInvitation = <ThrowOnError extends boolean = false>(options: Options<RevokeInvitationData, ThrowOnError>) => (options.client ?? client).delete<RevokeInvitationResponses, RevokeInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}/invitations/{invitation_token}/revoke',
    ...options
});

/**
 * List agent permissions
 *
 * List all users who have access to an agent (only visible to owner and users with write permission)
 */
export const listAgentPermissions = <ThrowOnError extends boolean = false>(options: Options<ListAgentPermissionsData, ThrowOnError>) => (options.client ?? client).get<ListAgentPermissionsResponses, ListAgentPermissionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}/permissions',
    ...options
});

/**
 * Remove user access
 *
 * Remove a user's access to an agent (requires owner or write permission).
 * Note: If the owner is removed, ownership transfers to the user performing the action.
 *
 */
export const removeAgentPermission = <ThrowOnError extends boolean = false>(options: Options<RemoveAgentPermissionData, ThrowOnError>) => (options.client ?? client).delete<RemoveAgentPermissionResponses, RemoveAgentPermissionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}/permissions/{user_id}',
    ...options
});

/**
 * Update user permission
 *
 * Update a user's permission level for an agent (requires owner or write permission).
 * Note: If the owner is removed, ownership transfers to the user performing the action.
 *
 */
export const updateAgentPermission = <ThrowOnError extends boolean = false>(options: Options<UpdateAgentPermissionData, ThrowOnError>) => (options.client ?? client).put<UpdateAgentPermissionResponses, UpdateAgentPermissionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}/permissions/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Leave shared agent
 *
 * Remove yourself from a shared agent (users can only remove themselves)
 */
export const leaveSharedAgent = <ThrowOnError extends boolean = false>(options: Options<LeaveSharedAgentData, ThrowOnError>) => (options.client ?? client).delete<LeaveSharedAgentResponses, LeaveSharedAgentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/{agent_id}/leave',
    ...options
});

/**
 * List shared agents
 *
 * List all agents that have been shared with the current user
 */
export const listSharedAgents = <ThrowOnError extends boolean = false>(options?: Options<ListSharedAgentsData, ThrowOnError>) => (options?.client ?? client).get<ListSharedAgentsResponses, ListSharedAgentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/shared',
    ...options
});

/**
 * List my invitations
 *
 * List all pending invitations for the current user
 */
export const listMyInvitations = <ThrowOnError extends boolean = false>(options?: Options<ListMyInvitationsData, ThrowOnError>) => (options?.client ?? client).get<ListMyInvitationsResponses, ListMyInvitationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agents/invitations',
    ...options
});

/**
 * List blocked users
 *
 * Get list of all users blocked by the current user
 */
export const listBlockedUsers = <ThrowOnError extends boolean = false>(options?: Options<ListBlockedUsersData, ThrowOnError>) => (options?.client ?? client).get<ListBlockedUsersResponses, ListBlockedUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/block',
    ...options
});

/**
 * Block a user
 *
 * Block a user by email or username to prevent them from sharing agents with you
 */
export const blockUser = <ThrowOnError extends boolean = false>(options: Options<BlockUserData, ThrowOnError>) => (options.client ?? client).post<BlockUserResponses, BlockUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/block',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unblock a user
 *
 * Remove a user from the blocked list
 */
export const unblockUser = <ThrowOnError extends boolean = false>(options: Options<UnblockUserData, ThrowOnError>) => (options.client ?? client).delete<UnblockUserResponses, UnblockUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/block/{block_id}',
    ...options
});

/**
 * List organizations
 *
 * Get paginated list of organizations the user has access to
 */
export const getOrganizations = <ThrowOnError extends boolean = false>(options?: Options<GetOrganizationsData, ThrowOnError>) => (options?.client ?? client).get<GetOrganizationsResponses, GetOrganizationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations',
    ...options
});

/**
 * Create organization
 *
 * Create a new organization. Requires organization creation permission.
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationData, ThrowOnError>) => (options.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete organization
 *
 * Delete an organization and all associated data. Requires owner permission.
 */
export const deleteOrganization = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationData, ThrowOnError>) => (options.client ?? client).delete<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}',
    ...options
});

/**
 * Get organization details
 *
 * Get detailed information about a specific organization
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}',
    ...options
});

/**
 * Update organization
 *
 * Update organization details. Requires admin or owner permission.
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>) => (options.client ?? client).put<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invite user to organization
 *
 * Send an invitation for a user to join the organization
 */
export const inviteToOrganization = <ThrowOnError extends boolean = false>(options: Options<InviteToOrganizationData, ThrowOnError>) => (options.client ?? client).post<InviteToOrganizationResponses, InviteToOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept organization invitation
 *
 * Accept a pending organization invitation
 */
export const acceptOrganizationInvitation = <ThrowOnError extends boolean = false>(options: Options<AcceptOrganizationInvitationData, ThrowOnError>) => (options.client ?? client).post<AcceptOrganizationInvitationResponses, AcceptOrganizationInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/invitations/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Share agent with organization
 *
 * Share an agent with all members of an organization
 */
export const shareAgentWithOrganization = <ThrowOnError extends boolean = false>(options: Options<ShareAgentWithOrganizationData, ThrowOnError>) => (options.client ?? client).post<ShareAgentWithOrganizationResponses, ShareAgentWithOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}/share-agent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List organization shared agents
 *
 * Get list of agents shared with the organization
 */
export const getOrganizationSharedAgents = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationSharedAgentsData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationSharedAgentsResponses, GetOrganizationSharedAgentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}/shared-agents',
    ...options
});

/**
 * Share collection with organization
 *
 * Share a collection with all members of an organization
 */
export const shareCollectionWithOrganization = <ThrowOnError extends boolean = false>(options: Options<ShareCollectionWithOrganizationData, ThrowOnError>) => (options.client ?? client).post<ShareCollectionWithOrganizationResponses, ShareCollectionWithOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}/share-collection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organization shared collections
 *
 * Get list of collections shared with an organization
 */
export const getOrganizationSharedCollections = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationSharedCollectionsData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationSharedCollectionsResponses, GetOrganizationSharedCollectionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}/shared-collections',
    ...options
});

/**
 * Get organization shared datasources
 *
 * Get list of datasources shared with an organization
 */
export const getOrganizationSharedDatasources = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationSharedDatasourcesData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationSharedDatasourcesResponses, GetOrganizationSharedDatasourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}/shared-datasources',
    ...options
});

/**
 * List organization members
 *
 * Get list of members in an organization
 */
export const getOrganizationMembers = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationMembersData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationMembersResponses, GetOrganizationMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}/members',
    ...options
});

/**
 * Remove member from organization
 *
 * Remove a member from an organization. Only owners and admins can remove members.
 */
export const removeOrganizationMember = <ThrowOnError extends boolean = false>(options: Options<RemoveOrganizationMemberData, ThrowOnError>) => (options.client ?? client).delete<RemoveOrganizationMemberResponses, RemoveOrganizationMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}/members/{member_id}',
    ...options
});

/**
 * Update member permission
 *
 * Update a member's permission level in the organization. Only owners can change permissions.
 */
export const updateMemberPermission = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberPermissionData, ThrowOnError>) => (options.client ?? client).put<UpdateMemberPermissionResponses, UpdateMemberPermissionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}/members/{member_id}/permission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List organization invitations
 *
 * Get list of pending invitations for an organization
 */
export const getOrganizationInvitations = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationInvitationsData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationInvitationsResponses, GetOrganizationInvitationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/organizations/{organization_id}/invitations',
    ...options
});

/**
 * Agent Proxy Command
 *
 * Forward encrypted command payload to agent and return encrypted response. This endpoint handles all data operations (INSERT, UPDATE, DELETE, SELECT) through encrypted communication with the database agent.
 */
export const agentProxyCommand = <ThrowOnError extends boolean = false>(options: Options<AgentProxyCommandData, ThrowOnError>) => (options.client ?? client).post<AgentProxyCommandResponses, AgentProxyCommandErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agent-proxy/{datasource_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Agent Proxy Stream Command
 *
 * Forward encrypted command payload to agent and stream responses via Server-Sent Events (SSE).
 *
 * This endpoint is similar to the regular agent-proxy endpoint but returns responses as a stream
 * of Server-Sent Events, enabling real-time streaming of results. This is particularly useful for:
 * - Long-running queries that return many rows
 * - Commands that generate incremental output (e.g., ASK_AI with streaming via OpenAI or Anthropic Claude)
 * - Real-time progress updates for operations
 *
 * The SSE stream follows this format:
 * - Initial connection: `data: {"status": "connected", "message": "SSE stream connected"}`
 * - Data chunks: `data: {"data": "<encrypted_payload>"}`
 * - Completion: `data: {"streaming_complete": true}`
 * - Errors: `data: {"error": "ERROR_CODE", "message": "Error description"}`
 *
 * Clients should handle the event stream and process chunks as they arrive.
 *
 */
export const agentProxyStreamCommand = <ThrowOnError extends boolean = false>(options: Options<AgentProxyStreamCommandData, ThrowOnError>) => (options.client ?? client).sse.post<AgentProxyStreamCommandResponses, AgentProxyStreamCommandErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agent-proxy/{datasource_id}/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * AI chat interface
 *
 * Chat with AI for database insights and assistance
 */
export const chatAi = <ThrowOnError extends boolean = false>(options: Options<ChatAiData, ThrowOnError>) => (options.client ?? client).post<ChatAiResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai/chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear chat history
 *
 * Delete all AI conversation history
 */
export const deleteAihistory = <ThrowOnError extends boolean = false>(options?: Options<DeleteAihistoryData, ThrowOnError>) => (options?.client ?? client).delete<DeleteAihistoryResponses, DeleteAihistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai/chat/history',
    ...options
});

/**
 * Get AI chat history
 *
 * Retrieve user's AI conversation history
 */
export const getAihistory = <ThrowOnError extends boolean = false>(options?: Options<GetAihistoryData, ThrowOnError>) => (options?.client ?? client).get<GetAihistoryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai/chat/history',
    ...options
});

/**
 * AI database analysis
 *
 * Get AI-powered database analysis and optimization suggestions
 */
export const analyzeAidatabase = <ThrowOnError extends boolean = false>(options: Options<AnalyzeAidatabaseData, ThrowOnError>) => (options.client ?? client).post<AnalyzeAidatabaseResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai/analyze-database',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * AI query generation
 *
 * Generate SQL query from natural language description
 */
export const executeQueryAi = <ThrowOnError extends boolean = false>(options: Options<ExecuteQueryAiData, ThrowOnError>) => (options.client ?? client).post<ExecuteQueryAiResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai/generate-query',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * AI query explanation
 *
 * Get AI explanation of a SQL query
 */
export const executeQueryAiexplain = <ThrowOnError extends boolean = false>(options: Options<ExecuteQueryAiexplainData, ThrowOnError>) => (options.client ?? client).post<ExecuteQueryAiexplainResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/ai/explain-query',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get application settings
 *
 * Retrieve current application settings
 */
export const getSettings = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsData, ThrowOnError>) => (options?.client ?? client).get<GetSettingsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings',
    ...options
});

/**
 * Update application settings
 *
 * Update application settings
 */
export const updateSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateSettingsData, ThrowOnError>) => (options.client ?? client).put<UpdateSettingsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get current session
 *
 * Retrieve information about the current user session
 */
export const getSession = <ThrowOnError extends boolean = false>(options?: Options<GetSessionData, ThrowOnError>) => (options?.client ?? client).get<GetSessionResponses, GetSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session',
    ...options
});

/**
 * List active sessions
 *
 * Get all active sessions for the current user
 */
export const getSessions = <ThrowOnError extends boolean = false>(options?: Options<GetSessionsData, ThrowOnError>) => (options?.client ?? client).get<GetSessionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/sessions',
    ...options
});

/**
 * Terminate session
 *
 * Terminate a specific user session
 */
export const deleteSessions = <ThrowOnError extends boolean = false>(options: Options<DeleteSessionsData, ThrowOnError>) => (options.client ?? client).delete<DeleteSessionsResponses, DeleteSessionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/sessions/{session_id}',
    ...options
});

/**
 * Get API site map
 *
 * Retrieve complete list of API endpoints
 */
export const getSitemap = <ThrowOnError extends boolean = false>(options?: Options<GetSitemapData, ThrowOnError>) => (options?.client ?? client).get<GetSitemapResponses, unknown, ThrowOnError>({ url: '/site-map', ...options });

/**
 * List collections
 *
 * Get paginated list of collections accessible to the user, including owned collections and shared collections.
 *
 * **Collection Access Types:**
 * 1. **Owned Collections**: Collections created by the user (user is the owner)
 * 2. **Shared Collections**: Collections shared with the user by other users (requires feature flag)
 * 3. **Public Collections**: Collections marked as public (accessible to all authenticated users with read-only access)
 *
 * **Shared Collections Feature:**
 * - Requires `enable_shared_collections` feature flag to be enabled for the user
 * - Collections shared with you will appear in this list with their respective permission levels
 * - Permission levels: `read`, `write`, or `admin`
 * - The `permissionLevel` field in the response indicates your access level for each collection
 *
 * **Response Includes:**
 * - Collections you own (permissionLevel: "owner" or highest available)
 * - Collections shared with you (if feature flag enabled)
 * - Public collections (permissionLevel: "read" unless you have explicit higher permissions)
 *
 * **Filtering Shared Collections:**
 * - Shared collections appear alongside owned collections
 * - Use the `owner` field in response to distinguish between owned and shared
 * - Collections are returned in order based on `orderIndex` and creation time
 *
 */
export const listCollections = <ThrowOnError extends boolean = false>(options?: Options<ListCollectionsData, ThrowOnError>) => (options?.client ?? client).get<ListCollectionsResponses, ListCollectionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections',
    ...options
});

/**
 * Create collection
 *
 * Create a new collection. The creating user becomes the owner and has full control over the collection.
 *
 * **Ownership and Sharing:**
 * - The user creating the collection becomes the permanent owner
 * - Owners can share their collections with other users if `enable_shared_collections` feature flag is enabled
 * - Owners can grant `read`, `write`, or `admin` permissions to other users
 * - Collections can be made public for read-only access by all authenticated users
 *
 * **After Creation:**
 * - Use `/api/collections/{collection_id}/permissions` endpoints to share the collection
 * - Use the `isPublic` field to make the collection publicly readable
 * - The owner always has full access and cannot lose ownership
 *
 */
export const createCollection = <ThrowOnError extends boolean = false>(options: Options<CreateCollectionData, ThrowOnError>) => (options.client ?? client).post<CreateCollectionResponses, CreateCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk reorder collections
 *
 * Reorder multiple collections at once by providing an ordered list of collection IDs.
 * All collections must belong to the current user and share the same parent collection.
 * The collections will be assigned order values starting from 0.
 *
 */
export const reorderCollections = <ThrowOnError extends boolean = false>(options: Options<ReorderCollectionsData, ThrowOnError>) => (options.client ?? client).post<ReorderCollectionsResponses, ReorderCollectionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete collection
 *
 * Delete a collection and optionally its contents.
 *
 * **Permission Requirements:**
 * - `owner`: Can always delete the collection
 * - `admin`: Cannot delete (only owner can delete)
 * - `write`: Can delete with `force=true` if the collection is empty or force flag is used
 * - `read`: Cannot delete (returns 403)
 *
 * **Deletion Behavior:**
 * - Without `force=true`: Collection must be empty (no queries, folders, or subcollections)
 * - With `force=true`: Deletes collection and all its contents (queries, folders, subcollections)
 * - Deleting a collection removes all permissions granted to other users
 * - Shared users lose access immediately upon deletion
 *
 * **Cascading Effects:**
 * - All permissions are deleted when the collection is deleted
 * - Subcollections are deleted if force=true
 * - All queries and folders within are deleted if force=true
 *
 * **Important Notes:**
 * - Only the owner can permanently delete a collection
 * - Users with write permission + force flag can delete, but this is permanent
 * - Consider moving queries to another collection before deletion if you want to preserve them
 *
 */
export const deleteCollection = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectionData, ThrowOnError>) => (options.client ?? client).delete<DeleteCollectionResponses, DeleteCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}',
    ...options
});

/**
 * Get collection details
 *
 * Get detailed information about a collection including queries and folders.
 *
 * **Access Requirements:**
 * - You can access this collection if you are:
 * - The owner of the collection
 * - A user with granted permissions (read, write, or admin) - requires feature flag
 * - Any authenticated user if the collection is public (read-only access)
 *
 * **Response Details:**
 * - The `permissionLevel` field indicates your access level: "owner", "admin", "write", or "read"
 * - The `owner` object shows who owns the collection
 * - For shared collections, you'll see the owner's information but can only perform actions based on your permission level
 *
 * **Permission-Based Access:**
 * - `read`: Can view collection details, queries, and folders
 * - `write`: Can view and modify collection contents
 * - `admin`: Can view, modify, and manage permissions
 * - `owner`: Full control including deletion and permission management
 *
 */
export const getCollection = <ThrowOnError extends boolean = false>(options: Options<GetCollectionData, ThrowOnError>) => (options.client ?? client).get<GetCollectionResponses, GetCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}',
    ...options
});

/**
 * Update collection
 *
 * Update collection properties. Access level determines what can be modified.
 *
 * **Permission Requirements:**
 * - `owner`: Can update all properties including making collection public/private
 * - `admin`: Can update all properties except ownership transfer
 * - `write`: Can update name, description, icon, color, metadata, and orderIndex
 * - `read`: Cannot update (returns 403)
 *
 * **Shared Collections Behavior:**
 * - Users with `write` or `admin` permissions can modify shared collections
 * - Changes are immediately visible to all users with access
 * - The `isPublic` field can only be changed by the owner
 * - Parent collection changes require write access to both current and target parent
 *
 */
export const updateCollection = <ThrowOnError extends boolean = false>(options: Options<UpdateCollectionData, ThrowOnError>) => (options.client ?? client).put<UpdateCollectionResponses, UpdateCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List queries in collection
 *
 * Get paginated list of queries in a collection.
 *
 * **Permission Requirements:**
 * - Any permission level (`read`, `write`, `admin`, or `owner`) can list queries
 * - Public collections allow read access to all authenticated users
 *
 */
export const listCollectionQueries = <ThrowOnError extends boolean = false>(options: Options<ListCollectionQueriesData, ThrowOnError>) => (options.client ?? client).get<ListCollectionQueriesResponses, ListCollectionQueriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/queries',
    ...options
});

/**
 * Create query in collection
 *
 * Create a new query in a collection.
 *
 * **Permission Requirements:**
 * - Requires at least `write` permission on the collection
 * - Users with `read` permission cannot create queries (returns 403)
 * - Owner and admin users can always create queries
 *
 */
export const createCollectionQuery = <ThrowOnError extends boolean = false>(options: Options<CreateCollectionQueryData, ThrowOnError>) => (options.client ?? client).post<CreateCollectionQueryResponses, CreateCollectionQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/queries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk reorder queries
 *
 * Reorder multiple queries at once within a collection by providing an ordered list of query IDs.
 * All queries must belong to the specified collection and share the same folder (or all be at root level).
 * The queries will be assigned order values starting from 0.
 *
 */
export const reorderCollectionQueries = <ThrowOnError extends boolean = false>(options: Options<ReorderCollectionQueriesData, ThrowOnError>) => (options.client ?? client).post<ReorderCollectionQueriesResponses, ReorderCollectionQueriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/queries/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete query
 *
 * Delete a query from a collection.
 *
 * **Permission Requirements:**
 * - Requires at least `write` permission on the collection
 * - Users with `read` permission cannot delete queries (returns 403)
 * - Owner, admin, and write users can delete any query in the collection
 *
 */
export const deleteCollectionQuery = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectionQueryData, ThrowOnError>) => (options.client ?? client).delete<DeleteCollectionQueryResponses, DeleteCollectionQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/queries/{query_id}',
    ...options
});

/**
 * Get query details
 *
 * Get detailed information about a query in a collection.
 *
 * **Permission Requirements:**
 * - Any permission level (`read`, `write`, `admin`, or `owner`) can view query details
 * - Public collections allow read access to all authenticated users
 *
 */
export const getCollectionQuery = <ThrowOnError extends boolean = false>(options: Options<GetCollectionQueryData, ThrowOnError>) => (options.client ?? client).get<GetCollectionQueryResponses, GetCollectionQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/queries/{query_id}',
    ...options
});

/**
 * Update query
 *
 * Update a query in a collection.
 *
 * **Permission Requirements:**
 * - Requires at least `write` permission on the collection
 * - Users with `read` permission cannot update queries (returns 403)
 * - Owner, admin, and write users can update any query in the collection
 *
 */
export const updateCollectionQuery = <ThrowOnError extends boolean = false>(options: Options<UpdateCollectionQueryData, ThrowOnError>) => (options.client ?? client).put<UpdateCollectionQueryResponses, UpdateCollectionQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/queries/{query_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move query
 *
 * Move a query to a different collection or folder
 */
export const moveCollectionQuery = <ThrowOnError extends boolean = false>(options: Options<MoveCollectionQueryData, ThrowOnError>) => (options.client ?? client).post<MoveCollectionQueryResponses, MoveCollectionQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/queries/{query_id}/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get collection permissions
 *
 * Retrieve the list of users who have been granted permissions to access this collection.
 *
 * **Prerequisites:**
 * - User must have the `enable_shared_collections` feature flag enabled (admin can set this via `/api/users/{user_id}/feature-flags`)
 * - Only the collection owner or users with `admin` permission level can view the permissions list
 * - The requesting user must have at least `admin` permission on the collection
 *
 * **Permission Levels:**
 * - `read`: Can view the collection and its contents (queries, folders)
 * - `write`: Can view and modify the collection (add/edit queries, create folders, update collection name)
 * - `admin`: Can view, modify, and manage permissions (grant/revoke access to other users)
 *
 * **Response Details:**
 * - Returns an array of all users with explicit permissions on this collection
 * - Does not include the owner (owner always has full access)
 * - For public collections, explicit permissions override the default public `read` access
 *
 * **Important Notes:**
 * - If the feature flag is disabled for the requesting user, this endpoint returns 403
 * - Permissions are cascading: when a user is deleted, their permissions are automatically removed
 * - When the owner is deleted, the entire collection and all permissions are deleted
 *
 */
export const getCollectionPermissions = <ThrowOnError extends boolean = false>(options: Options<GetCollectionPermissionsData, ThrowOnError>) => (options.client ?? client).get<GetCollectionPermissionsResponses, GetCollectionPermissionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/permissions',
    ...options
});

/**
 * Grant or update collection permission
 *
 * Grant or update permission for a user to access this collection. If the user already has permission, this will update their permission level.
 *
 * **Prerequisites:**
 * - Both the granting user and target user must have `enable_shared_collections` feature flag enabled
 * - The granting user must be either:
 * - The collection owner
 * - A user with `admin` permission level on this collection
 *
 * **Permission Levels:**
 * - `read`: User can view the collection, its queries, and folders but cannot make changes
 * - `write`: User can view and modify the collection contents (add/edit/delete queries, manage folders, rename collection, delete collection with force flag)
 * - `admin`: User has write permissions plus can manage other users' permissions (grant/revoke/update)
 *
 * **Workflow Example:**
 * ```
 * 1. Admin enables feature flag for users:
 * PUT /api/users/{owner_id}/feature-flags
 * Body: {"feature_flags": {"enable_shared_collections": true}}
 *
 * 2. Owner creates collection:
 * POST /api/collections
 * Body: {"name": "My Shared Collection"}
 *
 * 3. Owner grants permission to user (multiple ways supported):
 * POST /api/collections/{collection_id}/permissions
 * Body: {"userId": "user_id_here", "permissionLevel": "write"}
 * OR
 * Body: {"email": "user@example.com", "permissionLevel": "write"}
 * OR
 * Body: {"username": "target_username", "permissionLevel": "write"}
 *
 * 4. User can now access the collection based on their permission level
 * ```
 *
 * **Permission Transitions:**
 * - You can transition between any permission levels (read ↔ write ↔ admin)
 * - To change permission, simply call this endpoint again with the new level
 * - The response message will indicate if permission was "granted" (new) or "updated" (changed)
 *
 * **Restrictions:**
 * - Cannot grant permission to the collection owner (returns 400)
 * - Cannot grant invalid permission levels (returns 400)
 * - If target user's feature flag is disabled, they won't be able to access the collection even after permission is granted
 *
 * **Edge Cases:**
 * - For public collections: Explicit permissions override the default public `read` access
 * - Granting permission to a non-existent user returns 404
 * - If the owner's feature flag is disabled, no permission operations work (returns 403)
 *
 * **User Identification:**
 * - You can identify the target user by providing one of: `userId`, `email`, or `username`
 * - Priority order for resolution: userId > email > username (if multiple are provided)
 * - At least one identifier must be provided in the request
 * - Permission responses always include the user's email address for identification
 *
 */
export const grantCollectionPermission = <ThrowOnError extends boolean = false>(options: Options<GrantCollectionPermissionData, ThrowOnError>) => (options.client ?? client).post<GrantCollectionPermissionResponses, GrantCollectionPermissionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke collection permission
 *
 * Revoke a user's permission to access this collection. After revocation, the user will no longer be able to access the collection unless it's public (in which case they retain read-only access).
 *
 * **Prerequisites:**
 * - The requesting user must have `enable_shared_collections` feature flag enabled
 * - The requesting user must be either:
 * - The collection owner
 * - A user with `admin` permission level on this collection
 *
 * **Effects of Revocation:**
 * - User immediately loses access to the collection
 * - All of the user's active sessions with the collection are terminated
 * - If the collection is public, the user retains read-only access as a public user
 * - If the collection is private, the user loses all access
 *
 * **Important Behaviors:**
 * - You cannot revoke your own permissions (owner cannot revoke from themselves)
 * - Revoking from a user who doesn't have permission returns 404
 * - Revoking when your feature flag is disabled returns 403
 *
 * **Cascading Effects:**
 * - If a user with `admin` permission is revoked, any permissions they granted remain intact
 * - The original owner retains the ability to manage all permissions regardless of who granted them
 *
 * **Common Workflow:**
 * ```
 * 1. List current permissions:
 * GET /api/collections/{collection_id}/permissions
 *
 * 2. Identify user to revoke:
 * Find userId in the permissions array
 *
 * 3. Revoke permission:
 * DELETE /api/collections/{collection_id}/permissions/{user_id}
 *
 * 4. User no longer has access (returns 403 if they try to access)
 * ```
 *
 * **Race Conditions:**
 * - If you grant and immediately revoke, the revoke takes precedence
 * - If multiple admins manage permissions simultaneously, the last operation wins
 *
 */
export const revokeCollectionPermission = <ThrowOnError extends boolean = false>(options: Options<RevokeCollectionPermissionData, ThrowOnError>) => (options.client ?? client).delete<RevokeCollectionPermissionResponses, RevokeCollectionPermissionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/permissions/{user_id}',
    ...options
});

/**
 * List collection invitations
 *
 * List all invitations sent for a specific collection. This endpoint allows collection owners and administrators to view all invitation statuses (pending, accepted, rejected, expired) for their collection.
 *
 * **Prerequisites:**
 * - User must have the `enable_shared_collections` feature flag enabled
 * - User must be either:
 * - The collection owner
 * - A user with `admin` permission level on this collection
 *
 * **Response Details:**
 * - Returns all invitations regardless of status by default
 * - Use the `status` query parameter to filter by specific status
 * - Includes invitation tokens for revocation purposes
 * - Shows complete invitation history for the collection
 *
 * **Permission Levels in Results:**
 * - `read`: Invitee can view collection and contents
 * - `write`: Invitee can view and modify collection
 * - `admin`: Invitee can view, modify, and manage permissions
 *
 * **Status Types:**
 * - `pending`: Invitation sent but not yet responded to
 * - `accepted`: Invitation accepted and permission granted
 * - `rejected`: Invitation rejected or revoked by owner/admin
 * - `expired`: Invitation expired after 7 days without response
 *
 * **Use Cases:**
 * - Track invitation status for collaboration management
 * - Identify pending invitations that need follow-up
 * - Audit collection access history
 * - Revoke pending invitations if needed
 *
 * **Example Workflow:**
 * ```
 * 1. Collection owner invites users:
 * POST /api/collections/{collection_id}/invite
 *
 * 2. Owner checks invitation status:
 * GET /api/collections/{collection_id}/invitations
 *
 * 3. Filter for pending invitations:
 * GET /api/collections/{collection_id}/invitations?status=pending
 *
 * 4. Revoke invitation if needed:
 * DELETE /api/collections/{collection_id}/invitations/{token}/revoke
 * ```
 *
 */
export const listCollectionInvitations = <ThrowOnError extends boolean = false>(options: Options<ListCollectionInvitationsData, ThrowOnError>) => (options.client ?? client).get<ListCollectionInvitationsResponses, ListCollectionInvitationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/invitations',
    ...options
});

/**
 * Invite user to collection
 *
 * Send an invitation to share a collection with another user by email or username.
 *
 * **User Validation:** The system validates that the specified user exists before sending the invitation.
 * If no user is found with the provided email or username, a 404 USER_NOT_FOUND error is returned.
 *
 */
export const inviteUserToCollection = <ThrowOnError extends boolean = false>(options: Options<InviteUserToCollectionData, ThrowOnError>) => (options.client ?? client).post<InviteUserToCollectionResponses, InviteUserToCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept collection invitation
 *
 * Accept an invitation to access a shared collection
 */
export const acceptCollectionInvitation = <ThrowOnError extends boolean = false>(options: Options<AcceptCollectionInvitationData, ThrowOnError>) => (options.client ?? client).post<AcceptCollectionInvitationResponses, AcceptCollectionInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/invitations/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject collection invitation
 *
 * Reject an invitation to access a shared collection
 */
export const rejectCollectionInvitation = <ThrowOnError extends boolean = false>(options: Options<RejectCollectionInvitationData, ThrowOnError>) => (options.client ?? client).post<RejectCollectionInvitationResponses, RejectCollectionInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/invitations/{invitation_token}/reject',
    ...options
});

/**
 * Revoke pending invitation
 *
 * Revoke a pending invitation (inviter or collection admin only)
 */
export const revokeCollectionInvitation = <ThrowOnError extends boolean = false>(options: Options<RevokeCollectionInvitationData, ThrowOnError>) => (options.client ?? client).delete<RevokeCollectionInvitationResponses, RevokeCollectionInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/invitations/{invitation_token}/revoke',
    ...options
});

/**
 * List user's invitations
 *
 * Get list of invitations sent to the current user
 */
export const listUserInvitations = <ThrowOnError extends boolean = false>(options?: Options<ListUserInvitationsData, ThrowOnError>) => (options?.client ?? client).get<ListUserInvitationsResponses, ListUserInvitationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/invitations',
    ...options
});

/**
 * List shared collections
 *
 * Get collections shared with the current user
 */
export const listSharedCollections = <ThrowOnError extends boolean = false>(options?: Options<ListSharedCollectionsData, ThrowOnError>) => (options?.client ?? client).get<ListSharedCollectionsResponses, ListSharedCollectionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/shared',
    ...options
});

/**
 * Leave shared collection
 *
 * Remove yourself from a shared collection (cannot be used by collection owner)
 */
export const leaveSharedCollection = <ThrowOnError extends boolean = false>(options: Options<LeaveSharedCollectionData, ThrowOnError>) => (options.client ?? client).delete<LeaveSharedCollectionResponses, LeaveSharedCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/leave',
    ...options
});

/**
 * List folders in collection
 *
 * Get paginated list of folders in a collection
 */
export const listCollectionFolders = <ThrowOnError extends boolean = false>(options: Options<ListCollectionFoldersData, ThrowOnError>) => (options.client ?? client).get<ListCollectionFoldersResponses, ListCollectionFoldersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/folders',
    ...options
});

/**
 * Create folder
 *
 * Create a new folder in a collection
 */
export const createFolder = <ThrowOnError extends boolean = false>(options: Options<CreateFolderData, ThrowOnError>) => (options.client ?? client).post<CreateFolderResponses, CreateFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/folders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk reorder folders
 *
 * Reorder multiple folders at once within a collection by providing an ordered list of folder IDs.
 * All folders must belong to the specified collection and share the same parent folder.
 * The folders will be assigned order values starting from 0.
 *
 */
export const reorderCollectionFolders = <ThrowOnError extends boolean = false>(options: Options<ReorderCollectionFoldersData, ThrowOnError>) => (options.client ?? client).post<ReorderCollectionFoldersResponses, ReorderCollectionFoldersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/folders/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete folder
 *
 * Delete a folder. Use force=true to delete non-empty folders.
 */
export const deleteFolder = <ThrowOnError extends boolean = false>(options: Options<DeleteFolderData, ThrowOnError>) => (options.client ?? client).delete<DeleteFolderResponses, DeleteFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/folders/{folder_id}',
    ...options
});

/**
 * Get folder details
 *
 * Get detailed information about a folder including queries and subfolders
 */
export const getFolder = <ThrowOnError extends boolean = false>(options: Options<GetFolderData, ThrowOnError>) => (options.client ?? client).get<GetFolderResponses, GetFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/folders/{folder_id}',
    ...options
});

/**
 * Update folder
 *
 * Update folder properties
 */
export const updateFolder = <ThrowOnError extends boolean = false>(options: Options<UpdateFolderData, ThrowOnError>) => (options.client ?? client).put<UpdateFolderResponses, UpdateFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/collections/{collection_id}/folders/{folder_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
